// 脑计划
<template>
  <div class="programs">
    <div class="periodicals-heda">
      <div class="periodicals-heda-img">
        <img src="../../assets/img/home/framework.png">
      </div>
      <div class="periodicals-heda-text">{{$t('i18n.BrainPlan')}}</div>
    </div>
    <div class="contents">
      <div class="contents-tabs">
        <el-tabs
          v-model="activeName"
          @tab-click="handleClick"
        >
          <el-tab-pane
            :label="$t('i18n.China')"
            name="china"
          >
            <div class="contents-tabs-1">
              <div class="contents-tabs-1-contents">
                <div class="contents-tabs-1-contents-top">
                  <div class="contents-tabs-1-contents-img">
                    <img :src="imgURL+programsObj.thumb">
                  </div>
                  <div class="contents-tabs-1-contents-right">
                    <div class="contents-tabs-1-contents-right-head">
                      {{programsObj.title}}
                    </div>
                    <div class="contents-tabs-1-contents-right-text">
                      <div
                        v-html="programsObj.contentSingle.content"
                        class="html"
                      ></div>
                    </div>
                  </div>
                </div>
                <div class="contents-tabs-1-contents-bottom">
                  <div
                    class="contents-tabs-1-contents-bottom-box"
                    @click="guide1"
                  >
                    <div class="contents-tabs-1-contents-bottom-text">
                      {{$t('i18n.Learnmore')}}
                    </div>
                    <div class="contents-tabs-1-contents-bottom-img">
                      <img src="../../assets/img/home/right.png">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane
            :label="$t('i18n.USA')"
            name="unitedStates"
          >
            <div class="contents-tabs-1">
              <div class="contents-tabs-1-contents">
                <div class="contents-tabs-1-contents-top">
                  <div class="contents-tabs-1-contents-img">
                    <img :src="imgURL+programsObj.thumb">
                  </div>
                  <div class="contents-tabs-1-contents-right">
                    <div class="contents-tabs-1-contents-right-head">
                      {{programsObj.title}}
                    </div>
                    <div class="contents-tabs-1-contents-right-text ">
                      <div
                        v-html="programsObj.contentSingle.content"
                        class="html"
                      >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="contents-tabs-1-contents-bottom">
                  <div
                    class="contents-tabs-1-contents-bottom-box"
                    @click="guide2"
                  >
                    <div class="contents-tabs-1-contents-bottom-text">
                      {{$t('i18n.Learnmore')}}
                    </div>
                    <div class="contents-tabs-1-contents-bottom-img">
                      <img src="../../assets/img/home/right.png">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane
            :label="$t('i18n.USEuro')"
            name="europeAmerica"
          >
            <div class="contents-tabs-1">
              <div class="contents-tabs-1-contents">
                <div class="contents-tabs-1-contents-top">
                  <div class="contents-tabs-1-contents-img">
                    <img :src="imgURL+programsObj.thumb">
                  </div>
                  <div class="contents-tabs-1-contents-right">
                    <div class="contents-tabs-1-contents-right-head">
                      {{programsObj.title}}
                    </div>
                    <div class="contents-tabs-1-contents-right-text">
                      <div
                        v-html="programsObj.contentSingle.content"
                        class="html"
                      >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="contents-tabs-1-contents-bottom">
                  <div
                    class="contents-tabs-1-contents-bottom-box"
                    @click="guide3"
                  >
                    <div class="contents-tabs-1-contents-bottom-text">
                      {{$t('i18n.Learnmore')}}
                    </div>
                    <div class="contents-tabs-1-contents-bottom-img">
                      <img src="../../assets/img/home/right.png">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

  </div>
</template> 

<script>
export default {
  name: 'programs',
  data () {
    return {
      imgURL: '',
      activeName: 'china',
      programsObj: {
        contentSingle: {}
      }
    }
  },
  created () {
    this.imgURL = localStorage.getItem('imgURL')//切换中英文 
    this.getPrograms()
  },
  methods: {
    handleClick (tab, event) {
      this.getPrograms()
    },
    //获取脑库列表
    async getPrograms () {
      const { data: data } = await this.$http.get('single', {
        params: {
          cate_id: `/${this.activeName}`,
          lang: localStorage.getItem('Language')//切换中英文  
        }
      })
      this.programsObj = data.data
    },
    //临床指南
    guide1 () {
      this.$router.push('china')
    },
    //临床指南
    guide2 () {
      this.$router.push('unitedStates')
    },
    //临床指南
    guide3 () {
      this.$router.push('europeAmerica')
    }
  }
}

</script>
<style lang="less" scoped>
.programs {
  //头部
  .periodicals-heda {
    margin: 58px 0;
    display: flex;
    justify-content: center;
    position: relative;
    .periodicals-heda-img {
      width: 214px;
      height: 24px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .periodicals-heda-text {
      position: relative;
      top: -10px;
      // left: -115px;
      left: -7%;
      font-size: 20px;
      color: #393939;
      font-weight: 600;
    }
  }
  //内容
  .contents {
    padding: 0 190px;
    .contents-tabs {
      /deep/ .el-tabs__nav-wrap::after {
        background-color: #fff;
      }
      /deep/ .el-tabs__item {
        font-size: 20px;
        margin-bottom: 10px;
      }
      /deep/.el-tabs__item.is-active {
        font-size: 28px;
        font-weight: 600;
        color: #393939;
      }
      /deep/.el-tabs__active-bar {
        height: 8px;
        background: linear-gradient(132deg, #ff9598 0%, #ed6f56 100%);
        border-radius: 5px;
      }
      /deep/.is-top:nth-child(3) {
        padding: 0 170px;
      }
      /deep/.el-tabs__item:hover {
        color: #ed6f56;
        cursor: pointer;
      }
      .contents-tabs-1 {
        width: 100%;
        // background-color: #ed6f56;
        .contents-tabs-1-contents {
          margin: 3px;
          padding: 76px 35px 25px 35px;
          border-radius: 22px;
          background-color: #fff;
          box-shadow: 0px 3px 30px 1px #dfdfdf;

          .contents-tabs-1-contents-top {
            display: flex;
            .contents-tabs-1-contents-img {
              width: 423px;
              height: 329px;
              border-radius: 18px;
              overflow: hidden;
              margin-right: 66px;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .contents-tabs-1-contents-right {
              flex: 1;
              .contents-tabs-1-contents-right-head {
                font-size: 30px;
                font-weight: 600;
                color: #393939;
                margin-bottom: 38px;
              }
              .contents-tabs-1-contents-right-text {
                width: 100%;
                height: 240px;
                background-color: #f1f1f1;
                border-radius: 21px;
                padding: 42px 25px;
                line-height: 2;
                color: #1e1e1e;
                font-size: 16px;

                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 6;
                overflow: hidden;
                //----------------

                //----------------
              }
            }
          }

          .contents-tabs-1-contents-bottom {
            margin-top: 30px;
            display: flex;
            justify-content: flex-end;
            .contents-tabs-1-contents-bottom-box {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 115px;
              height: 35px;
              background-color: #ed6f56;
              border-radius: 3px;
              cursor: pointer;

              .contents-tabs-1-contents-bottom-text {
                color: #fff;
                font-size: 14px;
                margin-right: 5px;
                cursor: pointer;
              }
              .contents-tabs-1-contents-bottom-img {
                width: 15px;
                height: 11px;
                img {
                  margin-bottom: 5px;
                }
              }
            }
          }
        }
      }
    }
    .html {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 5;
      overflow: hidden;
    }
  }
}
</style>   